import MaterialIconsReact from "material-icons-react";
import { useCallback, useContext, useState } from "react";
import { UserContext } from "../context/UserContext";
import { useWalletAccess } from "../pages/Payments/hooks/useWalletAccess";
import VendorWalletModal from "../pages/Payments/modals/VendorWalletModal";
import styles from './Header.module.css';
import { useLocation, useNavigate } from "react-router-dom";

function Header(props) {
  const {currentFactory, invoiceFactory, setOpenMenu} = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [walletOpen, setWalletOpen] = useState(false);

  const isInvoiceManagementPage = location.pathname.includes(
    "/invoice-management"
  );
  // The header renders on every module (Beamsaw, QC…) but the wallet only ever
  // shows on invoice management, so skip the flag request everywhere else.
  const canViewWallet = useWalletAccess({ enabled: isInvoiceManagementPage });
  const isVendorOnboardingPage = location.pathname.includes(
    "/vendor-onboarding"
  );
  const isVendorProfilePage = location.pathname.includes(
    "/vendor-profile"
  );
  const hideFactoryUi = isVendorOnboardingPage || isVendorProfilePage;

  // Same gate as the Wallet tab (useWalletAccess): the `vip_wallet` flag plus
  // VENDOR_WALLET_VIEW, which is also what the VIP wallet read behind the popup
  // is authorized against.
  const showWallet =
    isInvoiceManagementPage &&
    canViewWallet &&
    invoiceFactory?.item_code &&
    invoiceFactory.item_code !== "all";

  const toggleSidebar = useCallback(() => {
    setOpenMenu((menu) => {
      localStorage.setItem('isMenuOpen', !menu);
      return !menu
    });
  }, [setOpenMenu])

  const handleProfileClick = useCallback(() => {
    navigate('/dashboard/vendor-profile');
  }, [navigate])

  return (
    <div className={styles.header}>
      <div className={styles.flexBlock}>
        {/* {(!selectedLocation || !selectedLocation.location) && <div className={styles.titleDropdown + ' ft-20'}>Beamsaw</div>} */}
        <MaterialIconsReact icon="menu" color={'#666666'} size={24} onClick={toggleSidebar}></MaterialIconsReact>
        <div className={styles.logoContainer}></div>
        <div className={styles.tarsTitle}>TARS</div>
        {/* <SearchInput focus={props.focus} placeholder="Search by work order" onSearch={props.onSearch} onItemSelection={updateWorkOrder}></SearchInput> */}
      </div>
      <div className={styles.flexBlock}>
        {!hideFactoryUi && (
          <span className={styles.workOrder + ' ft-16'} style={{marginRight: '8px'}}>{isInvoiceManagementPage ? (invoiceFactory?.item_code === 'all' ? 'All Factories' : (invoiceFactory?.item_name || '')) : (currentFactory?.item_name || '')}</span>
        )}
        <div className={styles.headerRight}>
          {!hideFactoryUi && (
            <MaterialIconsReact icon="domain" color={'#666666'} size={20} onClick={props.onFactoryClick}></MaterialIconsReact>
          )}
          {showWallet && (
            <MaterialIconsReact icon="account_balance_wallet" color={'#666666'} size={20} onClick={() => setWalletOpen(true)}></MaterialIconsReact>
          )}
          <MaterialIconsReact icon="notifications" color={'#666666'} size={20} invert></MaterialIconsReact>
          <span
            className={styles.userName + ' ft-14'}
            onClick={handleProfileClick}
            role="button"
            style={{ cursor: 'pointer' }}
            aria-label="Open vendor profile"
          >{props.user.name ? props.user.name[0] : ''}</span>
          <MaterialIconsReact icon="logout" color={'#666666'} size={20} onClick={props.logout}></MaterialIconsReact>
        </div>
      </div>

      {showWallet && walletOpen && (
        <VendorWalletModal
          open={walletOpen}
          onClose={() => setWalletOpen(false)}
          factoryCode={invoiceFactory.item_code}
          factoryName={invoiceFactory.item_name}
        />
      )}
    </div>
  );
}

export default Header;
